export default __webpack_public_path__ + "static/media/016-warning.0019e601.png";